var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackedArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 41,
    viewBox: "0 0 61 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1392_2785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8457 0.0310059V40.031H0.845703V29.391L22.8457 6.10101L40.8457 12.181L60.8457 0.0310059Z",
    fill: "url(#paint0_linear_1392_2785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8857 29.3211L22.8757 21.581L0.845703 34.5511V40.031H60.8457V18.201L40.8857 29.3211Z",
    fill: "url(#paint1_linear_1392_2785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.845703 40.031H60.8457",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1392_2785",
    x1: 30.8457,
    y1: 0.0310059,
    x2: 30.8457,
    y2: 40.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0298A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0298A6",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1392_2785",
    x1: 30.8457,
    y1: 18.201,
    x2: 30.8457,
    y2: 40.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#003F7F",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#003F7F",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003F7F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1392_2785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40.25,
    fill: "white",
    transform: "translate(0.845703 0.0310059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedArea);
export default __webpack_public_path__ + "static/media/stacked_area.12af83bc34b848dc484285e6c83f02c0.svg";
export { ForwardRef as ReactComponent };